import { apiType } from "./apiType";
import { IApplicantDetails, IApplicantUpdatePayload } from "@/src/types/applicant";

export interface IApplicantsListParams {
  email?: string;
  limit?: number;
  offset?: number;
}

export type IApplicantsListItem = Partial<IApplicantDetails> & {
  id: number;
  email?: string | null;
};

export type IApplicantsListResponse =
  | IApplicantsListItem[]
  | {
      data?: IApplicantsListItem[];
      items?: IApplicantsListItem[];
      results?: IApplicantsListItem[];
      total?: number;
      count?: number;
    };

const extractApplicantsListItems = (response: IApplicantsListResponse | null | undefined): IApplicantsListItem[] => {
  if (!response) return [];
  if (Array.isArray(response)) return response;
  if (Array.isArray(response.data)) return response.data;
  if (Array.isArray(response.items)) return response.items;
  if (Array.isArray(response.results)) return response.results;
  return [];
};

export const applicantsRequests = {
  getList: async ({ email, limit = 50, offset = 0 }: IApplicantsListParams): Promise<IApplicantsListItem[]> => {
    try {
      const response = await apiType.main.get<IApplicantsListResponse>(`/applicants/list`, {
        limit,
        offset,
        ...(email != null && email !== "" ? { email } : {}),
      });
      console.log(`[applicants/list] email=${email ?? ""}`, response);
      return extractApplicantsListItems(response);
    } catch (error) {
      console.log("This is applicants getList error:", error);
      return [];
    }
  },
  getById: async (applicantId: number): Promise<IApplicantDetails | null> => {
    try {
      const response = await apiType.main.get<IApplicantDetails>(`/applicants/${applicantId}`);
      console.log(`[applicants/getById] applicant_id=${applicantId}`, response);
      return response;
    } catch (error) {
      console.log("This is applicants getById error:", error);
      return null;
    }
  },
  update: async (applicantId: number, data: IApplicantUpdatePayload) => {
    try {
      return await apiType.main.put(`/applicants/${applicantId}`, data);
    } catch (error) {
      console.log("This is applicants update error:", error);
      return null;
    }
  },
};
